var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"unified-panel-body"},[_c('textarea',{attrs:{"name":"page_content","val":_vm.content}})])}
var staticRenderFns = []

export { render, staticRenderFns }